import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.as), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_progress_overlay, {
        visible: $options.isOverlayVisible,
        sticky: true
      }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 3 /* FORWARDED */
  }))
}